import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PublicShell from '../components/PublicShell';
import { authAPI } from '../services/api';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setMessage('');
    try {
      const res = await authAPI.forgotPassword(email.trim());
      setMessage(res.message || 'Wenn ein Konto existiert, wurde eine E-Mail gesendet.');
      setEmail('');
    } catch (err) {
      setError(err.response?.data?.message || 'Anfrage fehlgeschlagen.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <PublicShell narrow>
      <div className="auth-card">
        <span className="t12-badge">Tippspiel</span>
        <h1 className="section-title text-2xl md:text-3xl mb-1">Passwort vergessen</h1>
        <p className="text-sm text-white/50 mb-6">
          Gib die E-Mail-Adresse deines Kontos ein. Wir senden dir einen Link zum Zurücksetzen.
        </p>
        {message && <div className="alert-success-dark mb-4">{message}</div>}
        {error && <div className="alert-error-dark mb-4">{error}</div>}
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="label-dark" htmlFor="email">E-Mail</label>
            <input
              id="email"
              type="email"
              className="input-dark"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="email"
            />
          </div>
          <button type="submit" className="btn-wacker w-full" disabled={loading}>
            {loading ? 'Senden…' : 'Link anfordern'}
          </button>
        </form>
        <p className="text-center text-sm mt-6 text-white/50">
          <Link to="/login" className="text-primary-light hover:underline font-semibold">← Zur Anmeldung</Link>
        </p>
      </div>
    </PublicShell>
  );
};

export default ForgotPassword;
